@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث بعض الخطأ' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="retry.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد تصنيفات فرعية تطابق معايير البحث.' : 'No subcategories match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد تصنيفات فرعية' : 'No subcategories found.'"
    [emptyContentDescription]="isArabic() ? 'لا توجد تصنيفات فرعية في النظام.' : 'No subcategories found in the system.'" />

}
